import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { PriorityFilter } from '../../../../shared/models/priorityFilter';
import { PriorityCount } from '../../../../shared/models/priorityCount';
import { NItem } from '../../../../shared/models/NItem';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

export interface PriorityFilterState {
    priorities: Record<string, boolean>;
    subPriorities: Record<string, boolean>;
}

@Component({
    selector: 'cp-priority',
    templateUrl: './priority.component.html',
    styleUrls: ['./priority.component.scss']
})
export class PriorityComponent implements OnInit {

    private _featureFlagService = inject( FeatureFlagService );

    @Output() priorityFilter = new EventEmitter<PriorityFilter | PriorityFilterState>(); // Remove PriorityFilter with feature flag removal

    @Input() priorities: NItem[];
    @Input() clickable: boolean = false;
    @Input() featureFlag?: boolean = false;
    @Input() filterState: {
        priorities: Record<string, boolean>;
        subPriorities: Record<string, boolean>;
    } = {
        priorities: {},
        subPriorities: {}
    };
    protected showPriorityLegend: boolean = false;

    public prioritiesCounts: PriorityCount = {
        Overtime: 0,
        High: 0,
        HotParts: 0,
        Normal: 0,
        Warranty: 0,
        PM: 0,
        Locked: 0,
        SpecialEquipment: 0,
    };
    public prioritiesFilter: PriorityFilter = {
        Overtime: true,
        High: true,
        HotParts: true,
        Normal: true,
        Warranty: true,
        PM: true,
        Locked: true,
        SpecialEquipment: true,
    };

    // Refactored Code
    /*private priorityMap: Record<string, keyof PriorityCount> = {
        "Overtime Approved": "Overtime",
        "High": "High",
        "HOT PARTS - ASAP": "HotParts",
        "Normal": "Normal",
        "Warranty (Hot)": "Warranty",
        "PM": "PM",
        "LOCKED - SCHEDULED": "Locked",
        "Special Equipment": "SpecialEquipment",
    };*/


    public dispatchBoardPmSubCategorySorting: boolean = false;

    ngOnInit() {
        this.initData();
        this.dispatchBoardPmSubCategorySorting = this._featureFlagService.latestFeatureFlagSet["ui-dispatch-board-pm-sub-category-sorting"];
    }

    initData() {
        if (!this.dispatchBoardPmSubCategorySorting) {
            this.prioritiesCounts.Overtime = this.priorities ? this.priorities.findIndex(i => i.description === "Overtime Approved") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "Overtime Approved")].value : 0 : 0;
            this.prioritiesCounts.High = this.priorities ? this.priorities.findIndex(i => i.description === "High") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "High")].value : 0 : 0;
            this.prioritiesCounts.HotParts = this.priorities ? this.priorities.findIndex(i => i.description === "HOT PARTS - ASAP") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "HOT PARTS - ASAP")].value : 0 : 0;
            this.prioritiesCounts.Normal = this.priorities ? this.priorities.findIndex(i => i.description === "Normal") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "Normal")].value : 0 : 0;
            this.prioritiesCounts.Warranty = this.priorities ? this.priorities.findIndex(i => i.description === "Warranty (Hot)") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "Warranty (Hot)")].value : 0 : 0;
            this.prioritiesCounts.PM = this.priorities ? this.priorities.findIndex(i => i.description === "PM") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "PM")].value : 0 : 0;
            this.prioritiesCounts.Locked = this.priorities ? this.priorities.findIndex(i => i.description === "LOCKED - SCHEDULED") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "LOCKED - SCHEDULED")].value : 0 : 0;
            this.prioritiesCounts.SpecialEquipment = this.priorities ? this.priorities.findIndex(i => i.description === "Special Equipment") >= 0 ? this.priorities[this.priorities.findIndex(i => i.description === "Special Equipment")].value : 0 : 0;
        } else {
            const lookup = Object.fromEntries(
                (this.priorities || []).map(p => [p.description, p.value])
            );

            this.prioritiesCounts = {
                Overtime: lookup["Overtime Approved"] ?? 0,
                High: lookup["High"] ?? 0,
                HotParts: lookup["HOT PARTS - ASAP"] ?? 0,
                Normal: lookup["Normal"] ?? 0,
                Warranty: lookup["Warranty (Hot)"] ?? 0,
                PM: lookup["PM"] ?? 0,
                Locked: lookup["LOCKED - SCHEDULED"] ?? 0,
                SpecialEquipment: lookup["Special Equipment"] ?? 0,
            };
        }
    }

    // Deprecated
    toggleFilters(filter) {
        if (this.clickable) {
            switch (filter) {
                case 'Overtime Approved':
                    this.prioritiesFilter.Overtime = !this.prioritiesFilter.Overtime;
                    break;
                case 'High':
                    this.prioritiesFilter.High = !this.prioritiesFilter.High;
                    break;
                case 'HOT PARTS - ASAP':
                    this.prioritiesFilter.HotParts = !this.prioritiesFilter.HotParts;
                    break;
                case 'Normal':
                    this.prioritiesFilter.Normal = !this.prioritiesFilter.Normal;
                    break;
                case 'Warranty (Hot)':
                    this.prioritiesFilter.Warranty = !this.prioritiesFilter.Warranty;
                    break;
                case 'PM':
                    this.prioritiesFilter.PM = !this.prioritiesFilter.PM;
                    break;
                case 'LOCKED - SCHEDULED':
                    this.prioritiesFilter.Locked = !this.prioritiesFilter.Locked;
                    break;
                case 'Special Equipment':
                    this.prioritiesFilter.SpecialEquipment = !this.prioritiesFilter.SpecialEquipment;
                    break;
            }
            this.priorityFilter.emit(this.prioritiesFilter);
        }
    }

    togglePriority(priorityId: string) {
        if (!this.clickable) return;
        if (!this.filterState?.priorities) return;

        const updatedState = {
            priorities: {
                ...this.filterState.priorities,
                [priorityId]: !this.filterState.priorities[priorityId]
            },
            subPriorities: {
                ...this.filterState.subPriorities
            }
        };

        this.priorityFilter.emit(updatedState);
    }

    toggleSubPriority(subPriorityId: string) {
        if (!this.clickable) return;
        if (!this.filterState?.subPriorities) return;

        const updatedState = {
            priorities: {
                ...this.filterState.priorities
            },
            subPriorities: {
                ...this.filterState.subPriorities,
                [subPriorityId]: !this.filterState.subPriorities[subPriorityId]
            }
        };

        this.priorityFilter.emit(updatedState);
    }

    handleTooltipFilter(event: { type: string, id: string }) {
        if (event.type === 'priority') {
            this.togglePriority(event.id);
        }

        if (event.type === 'subPriority') {
            this.toggleSubPriority(event.id);
        }
    }

    togglePriorityLegend(event: boolean) {
        this.showPriorityLegend = event;
    }
}
